const Param = Object.freeze({
  TRACK_ID: 'trackId',
  PUBLISHER_ID: 'publisherId',
  DEVELOPER_NAME: 'developerName',
})

// The order of keys is important, it is used for route guard validation
const Query = Object.freeze({
  STORE: 'store',
  COUNTRY_CODE: 'countryCode',
  COUNTRY_CODES: 'countryCodes',
  CATEGORY_ID: 'categoryId',
  AGE_ID: 'ageId',
  CPP_FILTER: 'cppFilter',
  KEYWORD: 'keyword',
  DEVICE: 'device',
  DATE: 'date',
  SELECTED_DATE: 'selectedDate',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  COMPARE_START_DATE: 'compareStartDate',
  COMPARE_END_DATE: 'compareEndDate',
  ACTIVE_APP: 'activeApp',
  SORT_TYPE: 'sortType',
  CHART_SCALE: 'chartScale',
  CHART_DATA_MODE: 'chartDataMode',
  LANGUAGE_CODE: 'languageCode',
  CATEGORIES: 'categories',
  MONTH: 'month',
  YEAR: 'year',
  KEYWORDS: 'keywords',
  APP_UPDATE_TYPES: 'appUpdateTypes',
  CATEGORY_TYPE: 'categoryType',
  RANK_TYPE: 'rankType',
  VIDEO_FILTER: 'videoFilter',
  AD_NETWORK: 'adNetwork',
  COUNTRY_FILTER: 'countryFilter',
  APP_TAXONOMIES: 'appTaxonomies',
  GAME_TAXONOMIES: 'gameTaxonomies',
  PRODUCT_FAMILY: 'productFamily',
})

const TitleFont = Object.freeze({
  TITLE: 'title',
  HEADLINE: 'headline',
  SUB_HEADLINE: 'sub-headline',
})

const RouteName = Object.freeze({
  PATH_MATCH: 'path-match',
  NOT_FOUND: 'not-found',
  MAIN: 'main',
  BLANK: 'blank',
  AUTH: 'auth',
  AUTH_LOGIN_LAYOUT: 'auth_login-layout',
  AUTH__REGISTER_LAYOUT: 'blank_register-layout',
  AUTH_REGISTER: 'auth_register',
  AUTH_REGISTER_VERIFY: 'auth_register-verify',
  AUTH_REGISTER_SUCCESS: 'auth_register-success',
  AUTH_LOGIN: 'auth_login',
  AUTH_LOGIN_SSO: 'auth_login-sso',
  AUTH_LOGOUT: 'auth_logout',
  AUTH_RECOVER: 'auth_recover',
  AUTH_RECOVER_RESET: 'auth_recover-reset',
  AUTH_CALLBACK: 'auth_callback',
  AUTH_INVITE_COMPLETE: 'auth_invite-complete',
  AUTH_IMPERSONATION_LAYOUT: 'auth_impersonation-layout',
  AUTH_IMPERSONATION: 'auth_impersonation',
  AUTH_DELETE_ACCOUNT: 'auth_delete_account',
  ONBOARDING: 'onboarding',
  ONBOARDING_WELCOME: 'onboarding_welcome',
  ONBOARDING_SELECT_APP: 'onboarding_select-app',
  ONBOARDING_SELECT_COMPETITORS: 'onboarding_select-competitors',
  ONBOARDING_SELECT_KEYWORDS: 'onboarding_select-keywords',
  ONBOARDING_PRICING: 'onboarding_pricing',
  ONBOARDING_PAYMENT: 'onboarding_payment',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  USER: 'user',
  USER_CUSTOM_ALERTS: 'user_custom-alerts',
  ACCOUNT_SETTINGS: 'account-settings',
  ACCOUNT_SETTINGS_USER_DETAILS: 'account-settings_user-details',
  ACCOUNT_SETTINGS_BILLING: 'account-settings_billing',
  ACCOUNT_SETTINGS_PLANS: 'account-settings_plans',
  ACCOUNT_SETTINGS_TEAM_MEMBERS: 'account-settings_team-members',
  ACCOUNT_SETTINGS_API_USAGE: 'account-settings_api-usage',
  ACCOUNT_SETTINGS_SSO_SETTINGS: 'account-settings_sso-settings',
  ACCOUNT_SETTINGS_USER_INTEGRATION: 'account-settings-user_integration',
  USER_SLACK_INTEGRATION: 'user_slack-integration',
  USER_SUBSCRIPTION: 'user_subscription',
  APP_INTELLIGENCE: 'app-intelligence',
  APP_INTELLIGENCE_COMPASS: 'app-intelligence_compass',
  APP_INTELLIGENCE_COMPASS_EXPLORE: 'app-intelligence_compass_explore',
  APP_INTELLIGENCE_COMPASS_TRACE: 'app-intelligence_compass_trace',
  APP_INTELLIGENCE_COMPASS_IMPACT: 'app-intelligence_compass_impact',
  APP_INTELLIGENCE_ANALYSIS: 'app-intelligence_analysis',
  APP_INTELLIGENCE_ANALYSIS_APP_PROFILE: 'app-intelligence_analysis_app-profile',
  APP_INTELLIGENCE_ANALYSIS_PUBLISHER_PROFILE: 'app-intelligence_analysis_publisher-profile',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS: 'app-intelligence_analysis_featured-apps',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_IOS: 'app-intelligence_analysis_featured-apps_ios',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_IOS_TODAY_TAB: 'app-intelligence_analysis_featured-apps_ios_today-tab',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_IOS_GAMES_TAB: 'app-intelligence_analysis_featured-apps_ios_games-tab',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_IOS_APPS_TAB: 'app-intelligence_analysis_featured-apps_ios_apps-tab',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_PLAY: 'app-intelligence_analysis_featured-apps_play',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_PLAY_APPS_TAB: 'app-intelligence_analysis_featured-apps_play_apps-tab',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_PLAY_GAMES_TAB: 'app-intelligence_analysis_featured-apps_play_games-tab',
  APP_INTELLIGENCE_ANALYSIS_FEATURED_APPS_PLAY_FAMILY_TAB: 'app-intelligence_analysis_featured-apps_play_family-tab',
  APP_INTELLIGENCE_ANALYSIS_CATEGORY_RANKINGS: 'app-intelligence_analysis_category-rankings',
  APP_INTELLIGENCE_ANALYSIS_CATEGORY_RANKINGS_DAILY_RANKING_HISTORY_TAB: 'app-intelligence_analysis_category-rankings_daily-ranking-history_tab',
  APP_INTELLIGENCE_ANALYSIS_CATEGORY_RANKINGS_DAILY_COUNTRY_RANKING_TAB: 'app-intelligence_analysis_category-rankings_daily-country-ranking_tab',
  APP_INTELLIGENCE_ANALYSIS_REVIEWS: 'app-intelligence_analysis_reviews',
  APP_INTELLIGENCE_ANALYSIS_REVIEWS_REVIEW_ANALYSIS: 'app-intelligence_analysis_reviews_review-analysis',
  APP_INTELLIGENCE_ANALYSIS_REVIEWS_MOST_MENTIONED_KEYWORDS_ANALYSIS: 'app-intelligence_analysis_reviews_most-mentioned-keywords-analysis',
  APP_INTELLIGENCE_ANALYSIS_RATINGS: 'app-intelligence_analysis_ratings',
  APP_INTELLIGENCE_ANALYSIS_RATINGS_TOTAL_RATINGS_TAB: 'app-intelligence_analysis_ratings_total-ratings_tab',
  APP_INTELLIGENCE_ANALYSIS_RATINGS_DAILY_RATINGS_TAB: 'app-intelligence_analysis_ratings_daily-ratings_tab',
  APP_INTELLIGENCE_ANALYSIS_SIMILAR_APPS: 'app-intelligence_analysis_similar-apps',
  APP_INTELLIGENCE_ANALYSIS_SIMILAR_APPS_TAB: 'app-intelligence_analysis_similar-apps_tab',
  APP_INTELLIGENCE_ANALYSIS_SIMILAR_APPS_LISTED_AS_A_SIMILAR_APP_TAB: 'app-intelligence_analysis_similar-apps_listed-as-a-similar-app_tab',
  APP_INTELLIGENCE_ANALYSIS_SALES_METRICS: 'app-intelligence_analysis_sales-metrics',
  APP_INTELLIGENCE_ANALYSIS_SALES_METRICS_DOWNLOAD_HISTORY: 'app-intelligence_analysis_sales-metrics_download-history',
  APP_INTELLIGENCE_ANALYSIS_SALES_METRICS_REVENUE_HISTORY: 'app-intelligence_analysis_sales-metrics_revenue_history',
  APP_INTELLIGENCE_ANALYSIS_SALES_METRICS_PRODUCT_PAGE_VIEWS: 'app-intelligence_analysis_sales-metrics_product-page-views',
  APP_INTELLIGENCE_ANALYSIS_SALES_METRICS_RETENTION_HISTORY: 'app-intelligence_analysis_sales-metrics_retention-history',
  APP_INTELLIGENCE_ANALYSIS_IN_APP_EVENTS: 'app-intelligence_analysis_in-app-events',
  APP_INTELLIGENCE_ANALYSIS_IN_APP_EVENTS_CATEGORY_EVENTS_TAB: 'app-intelligence_analysis_in-app-events_category-events_tab',
  APP_INTELLIGENCE_ANALYSIS_IN_APP_EVENTS_APP_EVENTS_TAB: 'app-intelligence_analysis_in-app-events_app-events_tab',
  APP_INTELLIGENCE_ANALYSIS_IN_APP_EVENTS_ALL_EVENTS_TAB: 'app-intelligence_analysis_in-app-events_all-events_tab',
  APP_INTELLIGENCE_ANALYSIS_PROMOTIONAL_CONTENT: 'app-intelligence_analysis_promotional-content',
  APP_INTELLIGENCE_ANALYSIS_PROMOTIONAL_CONTENT_CATEGORY_EVENTS_TAB: 'app-intelligence_analysis_promotional-content_category-events_tab',
  APP_INTELLIGENCE_ANALYSIS_PROMOTIONAL_CONTENT_APP_EVENTS_TAB: 'app-intelligence_analysis_promotional-app-events_tab',
  APP_INTELLIGENCE_ANALYSIS_PROMOTIONAL_CONTENT_ALL_EVENTS_TAB: 'app-intelligence_analysis_promotional-all-events_tab',
  APP_INTELLIGENCE_TOP_CHARTS: 'app-intelligence_top-charts',
  APP_INTELLIGENCE_TOP_CHARTS_LEADERBOARD: 'app-intelligence_top-charts_leaderboard',
  APP_INTELLIGENCE_TOP_CHARTS_BIGGEST_MOVERS: 'app-intelligence_top-charts_biggest-movers',
  APP_INTELLIGENCE_TOP_CHARTS_BIGGEST_LOSERS: 'app-intelligence_top-charts_biggest-losers',
  APP_INTELLIGENCE_TOP_CHARTS_NEW_APPS: 'app-intelligence_top-charts_new-apps',
  ASO_INTELLIGENCE: 'aso-intelligence',
  ASO_INTELLIGENCE_METADATA: 'aso-intelligence_metadata',
  ASO_INTELLIGENCE_METADATA_ASO_OVERVIEW: 'aso-intelligence_metadata_aso-overview',
  ASO_INTELLIGENCE_METADATA_METADATA_OPTIMIZER: 'aso-intelligence_metadata_metadata-optimizer',
  ASO_INTELLIGENCE_METADATA_APP_UPDATE_TIMELINE: 'aso-intelligence_metadata_app-update-timeline',
  ASO_INTELLIGENCE_METADATA_CREATIVE_MONITORING: 'aso-intelligence_metadata_creative-monitoring',
  ASO_INTELLIGENCE_METADATA_CREATIVE_MONITORING_CREATIVES_BY_CATEGORY_TAB: 'aso-intelligence_metadata_creative-monitoring_creatives-by-category_tab',
  ASO_INTELLIGENCE_METADATA_CREATIVE_MONITORING_CREATIVES_BY_APP_TAB: 'aso-intelligence_metadata_creative-monitoring_creatives-by-app_tab',
  ASO_INTELLIGENCE_METADATA_LOCALIZATION: 'aso-intelligence_metadata_localization',
  ASO_INTELLIGENCE_METADATA_STORE_MANAGEMENT: 'aso-intelligence_metadata_store-management',
  ASO_INTELLIGENCE_KEYWORD: 'aso-intelligence_keyword',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRACKING: 'aso-intelligence_keyword_keyword-tracking',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRACKING_TRACKED_KEYWORDS_TAB: 'aso-intelligence_keyword_keyword-tracking_tracked-keywords_tab',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRACKING_COMPETITOR_ANALYSIS_TAB: 'aso-intelligence_keyword_keyword-tracking_competitor-analysis_tab',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRACKING_RANKING_HISTORY_TAB: 'aso-intelligence_keyword_keyword-tracking_ranking-history_tab',
  ASO_INTELLIGENCE_KEYWORD_COMPETITOR_KEYWORDS: 'aso-intelligence_keyword_competitor-keywords',
  ASO_INTELLIGENCE_KEYWORD_COMPETITOR_KEYWORDS_DIRECT_COMPARISON_TAB: 'aso-intelligence_keyword_competitor-keywords_direct-comparison_tab',
  ASO_INTELLIGENCE_KEYWORD_COMPETITOR_KEYWORDS_MULTI_COMPARISON_TAB: 'aso-intelligence_keyword_competitor-keywords_multi-comparison_tab',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_INSPECTOR: 'aso-intelligence_keyword_keyword-inspector',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_INSPECTOR_KEYWORD_ANALYSIS: 'aso-intelligence_keyword_keyword-inspector_keyword-analysis',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_INSPECTOR_PERFORMANCE_COMPARISON: 'aso-intelligence_keyword_keyword-inspector_performance-comparison',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRENDS: 'aso-intelligence_keyword_keyword-trends',
  ASO_INTELLIGENCE_KEYWORD_KEYWORD_TRANSLATOR: 'aso-intelligence_keyword_keyword-translator',
  ASO_INTELLIGENCE_PERFORMANCE: 'aso-intelligence_performance',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_REPORT: 'aso-intelligence_performance_download-report',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_REPORT_INTEGRATION: 'aso-intelligence_performance_download-report_integration',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_REPORT_DASHBOARD: 'aso-intelligence_performance_download-report_dashboard',
  ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT: 'aso-intelligence_performance_aso-report',
  ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT_ALL_RANKED_KEYWORDS: 'aso-intelligence_performance_aso-report_all-ranked-keywords',
  ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT_TRACKED_KEYWORDS: 'aso-intelligence_performance_aso-report_tracked-keywords',
  ASO_INTELLIGENCE_PERFORMANCE_VISIBILITY_REPORT: 'aso-intelligence_performance_visibility-report',
  ASO_INTELLIGENCE_PERFORMANCE_VISIBILITY_REPORT_VISIBILITY_SNAPSHOT_TAB: 'aso-intelligence_performance_visibility-report_visibility-snapshot_tab',
  ASO_INTELLIGENCE_PERFORMANCE_VISIBILITY_REPORT_LOCALIZATION_PERFORMANCE_TAB: 'aso-intelligence_performance_visibility-report_localization-performance_tab',
  ASO_INTELLIGENCE_PERFORMANCE_VISIBILITY_REPORT_TOP_VISIBLE_APPS_TAB: 'aso-intelligence_performance_visibility-report_top-visible-apps_tab',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_SHARE: 'aso-intelligence_performance_download-share',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_SHARE_KEYWORDS_TAB: 'aso-intelligence_performance_download-share_keywords-tab',
  ASO_INTELLIGENCE_PERFORMANCE_DOWNLOAD_SHARE_ORGANIC_DOWNLOAD_HISTORY_TAB: 'aso-intelligence_performance_download-share_organic-download-history-tab',
  SEARCH_ADS_INTELLIGENCE: 'search-ads-intelligence',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT: 'search-ads-intelligence_add-placement',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULT_APP: 'search-ads-intelligence_add-placement_search-result-app',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULT_KEYWORD: 'search-ads-intelligence_add-placement_search-result-keyword',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULT_COMPETITOR: 'search-ads-intelligence_add-placement_search-result-competitor',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULTS_TODAY_TAB: 'search-ads-intelligence_add-placement_search-results_today-tab',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULTS_SEARCH_TAB: 'search-ads-intelligence_add-placement_search-results_search-tab',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULTS_PRODUCT_PAGES: 'search-ads-intelligence_add-placement_search-results-product-pages',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULTS_PRODUCT_PAGES_APPS_ON_MY_PAGE_TAB: 'search-ads-intelligence_add-placement_search-results-product-pages_apps-on-my-page-tab',
  SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULTS_PRODUCT_PAGES_APPS_ADVERTISED_ON_TAB: 'search-ads-intelligence_add-placement_search-results-product-pages_apps-advertised-on-tab',
  SEARCH_ADS_INTELLIGENCE_TOP_CHARTS: 'search-ads-intelligence_top-charts',
  SEARCH_ADS_INTELLIGENCE_TOP_CHARTS_TOP_ADVERTISERS: 'search-ads-intelligence_top-charts_top-advertisers',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES: 'search-ads-intelligence_custom-product-pages',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_INTELLIGENCE: 'search-ads-intelligence_custom-product-pages_cpp-intelligence',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_INTELLIGENCE_CPP_BY_APP: 'search-ads-intelligence_custom-product-pages_cpp-intelligence_cpp-by-app',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_INTELLIGENCE_CPP_BY_KEYWORD: 'search-ads-intelligence_custom-product-pages_cpp-intelligence_cpp-by-keyword',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_INTELLIGENCE_CPP_BY_CATEGORY: 'search-ads-intelligence_custom-product-pages_cpp-intelligence_cpp-by-category',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_INTELLIGENCE_CPP_BY_AD_NETWORK: 'search-ads-intelligence_custom-product-pages_cpp-intelligence_cpp-by-ad-network',
  SEARCH_ADS_INTELLIGENCE_CUSTOM_PRODUCT_PAGES_CPP_METRICS: 'search-ads-intelligence_custom-product-pages_cpp-metrics',
  MARKET_INTELLIGENCE: 'market-intelligence',
  MARKET_INTELLIGENCE_ANALYSIS: 'market-intelligence_analysis',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS: 'market-intelligence_analysis_app-analysis',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS_DOWNLOAD_ESTIMATION_TAB: 'market-intelligence_analysis_app-analysis_download-estimation-tab',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS_REVENUE_ESTIMATION_TAB: 'market-intelligence_analysis_app-analysis_revenue-estimation-tab',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS_DAU_TAB: 'market-intelligence_analysis_app-analysis_dau-tab',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS_MAU_TAB: 'market-intelligence_analysis_app-analysis_mau-tab',
  MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS_AUDIENCE_GEOGRAPHY_TAB: 'market-intelligence_analysis_app-analysis_audience-geography-tab',
  MARKET_INTELLIGENCE_ANALYSIS_STORE_ANALYSIS: 'market-intelligence_analysis_store-analysis',
  MARKET_INTELLIGENCE_ANALYSIS_PUBLISHER_ANALYSIS: 'market-intelligence_analysis_publisher-analysis',
  MARKET_INTELLIGENCE_TOP_CHARTS: 'market-intelligence_top-charts',
  MARKET_INTELLIGENCE_TOP_CHARTS_TOP_APPS: 'market-intelligence_top-charts_top-apps',
  MARKET_INTELLIGENCE_TOP_CHARTS_TOP_PUBLISHERS: 'market-intelligence_top-charts_top-publishers',
  AD_INTELLIGENCE: 'ad-intelligence',
  AD_INTELLIGENCE_CREATE: 'ad-intelligence_create',
  AD_INTELLIGENCE_MANAGE: 'ad-intelligence_manage',
  AD_INTELLIGENCE_ANALYSIS: 'ad-intelligence_analysis',
  AD_INTELLIGENCE_ANALYSIS_CREATIVE_ANALYSIS: 'ad-intelligence_analysis_creative-analysis',
  AD_INTELLIGENCE_ANALYSIS_ADVERTISER_ANALYSIS: 'ad-intelligence_analysis_advertiser-analysis',
  AD_INTELLIGENCE_ANALYSIS_AD_PUBLISHER_ANALYSIS: 'ad-intelligence_analysis_ad-publisher-analysis',
  AD_INTELLIGENCE_ANALYSIS_DEVELOPER_ANALYSIS: 'ad-intelligence_analysis_developer-analysis',
  AD_INTELLIGENCE_ANALYSIS_MEDIA_ANALYSIS: 'ad-intelligence_analysis_media-analysis',
  AD_INTELLIGENCE_ANALYSIS_PUBLISHER_ANALYSIS: 'ad-intelligence_analysis_publisher-analysis',
  AD_INTELLIGENCE_ANALYSIS_LIST_OF_ADVERTISERS_ANALYSIS: 'ad-intelligence_analysis_list-of-advertisers-analysis',
  AD_INTELLIGENCE_ANALYSIS_LIST_OF_AD_PUBLISHERS_ANALYSIS: 'ad-intelligence_analysis_list-of-ad-publishers-analysis',
  AD_INTELLIGENCE_ANALYSIS_AD_NETWORKS_ANALYSIS: 'ad-intelligence_analysis_ad-networks-analysis',
  AD_INTELLIGENCE_TOP_CHARTS: 'ad-intelligence_top-charts',
  AD_INTELLIGENCE_TOP_CHARTS_TOP_ADVERTISERS: 'ad-intelligence_top-charts_top-advertisers',
  AD_INTELLIGENCE_TOP_CHARTS_TOP_AD_PUBLISHERS: 'ad-intelligence_top-charts_top-ad-publishers',
  AD_INTELLIGENCE_TOP_CHARTS_TOP_CREATIVES: 'ad-intelligence_top-charts_top-creatives',
  AD_INTELLIGENCE_TOP_CHARTS_TOP_DEVELOPERS: 'ad-intelligence_top-charts_top-developers',
  AD_INTELLIGENCE_COLLECTION: 'ad-intelligence_collection',
  AD_INTELLIGENCE_COLLECTION_APP_COLLECTIONS: 'ad-intelligence_collection_app-collections',
  AD_INTELLIGENCE_COLLECTION_CREATIVE_COLLECTIONS: 'ad-intelligence_collection_creative-collections',

  // PDF Report Routes
  PDF_REPORT: 'pdf-report',
  PDF_REPORT_EXPLORE: 'pdf-report_explore',

  // Callback Routes
  CALLBACK: `callback`,
  CALLBACK_PLAY_STORE_INTEGRATION: `play-store-integration`,
})

const MAIN_PAGE_ROUTE_NAME = RouteName.APP_INTELLIGENCE_COMPASS_EXPLORE

export {
  MAIN_PAGE_ROUTE_NAME,
  Param,
  Query,
  RouteName,
  TitleFont,
}
